import React from 'react';
import NoContentPlaceholder from '../../../components/NoContentPlaceholder/NoContentPlaceholder';
import GameCardsGridVirtualized from '../../components/GameCardsGrid/GameCardsGridVirtualized';
import { useInfinityQueryGames } from '../../../hooks/API/useQueryGames';
import { DEFAULT_QUERY_LIMIT } from '../../../hooks/API/constants';
import ReviewTwoColumnLayout from '../../layouts/TwoColumnLayout/TwoColumnLayout';
import ScrollRestoration from '../../../components/ScrollRestoration/ScrollRestoration';
import Heading from '../../../components/Heading/Heading';
import AppReviewHeader from '../../components/AppReviewHeader/AppReviewHeader';
import Local from '../../../components/Local/Local';
import { isEmpty } from 'ramda';
import { useNativeCasinoProvider } from '../../hooks/useNativeCasinoProvider';

const AppReviewDashboard = () => {
  const provider = useNativeCasinoProvider();

  const { isLoading, data, hasNextPage, fetchNextPage, isSuccess } =
    useInfinityQueryGames({
      provider,
    });

  return (
    <ScrollRestoration>
      <ReviewTwoColumnLayout>
        <AppReviewHeader />

        {isSuccess && isEmpty(data.pages) ? (
          <NoContentPlaceholder />
        ) : (
          <>
            <Heading isLoading={isLoading}>
              <Local>Slots</Local>
            </Heading>
            <GameCardsGridVirtualized
              items={data.pages}
              loadMoreGames={fetchNextPage}
              isLoading={hasNextPage || isLoading}
              limit={DEFAULT_QUERY_LIMIT}
            />
          </>
        )}
      </ReviewTwoColumnLayout>
    </ScrollRestoration>
  );
};

export default AppReviewDashboard;
